import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

interface RoutinesConfigOptions {
	hasRoutineVariation?: boolean;
}

export const getRoutinesConfig = (options: RoutinesConfigOptions = {}): FtuxConfig => {
	const { hasRoutineVariation = false } = options;

	const steps: FtuxStep[] = [
		{
			type: 'modal',
			title: 'Teaching Routines',
			subtitle:
				"Find our simple, pre-prepared lesson slides to teach high-quality lessons here. Let's explore this area and how to find the relevant teaching routine slides.",
			image: '/img/ftux-routines-1.png',
			button: {
				label: 'Next',
				type: 'paginated',
				hasBackButton: false
			},
			modalPosition: 'bottom-right',
			hasBackdrop: false
		}
	];

	steps.push({
		type: 'tooltip',
		target: '#routine-info-button',
		subtitle:
			'To learn about a particular teaching routine, click the <strong>Info </strong>button in the corner of the routine thumbnail.',
		tooltipPlacement: 'right',
		requireTargetActive: true,
		button: {
			label: 'Next',
			type: 'paginated'
		}
	});

	steps.push({
		type: 'tooltip',
		target: '#routine-filter',
		subtitle: 'Find a specific teaching routine by typing your search term here.',
		tooltipPlacement: 'right',
		requireTargetActive: true,
		button: {
			label: 'Next',
			type: 'paginated'
		}
	});

	steps.push({
		type: 'tooltip',
		target: '#routine-card',
		subtitle: 'Ready to teach a routine in class? Select a routine from the list to see options.',
		tooltipPlacement: 'right',
		requireTargetActive: true,
		button: {
			label: 'Next',
			type: 'paginated'
		}
	});

	if (hasRoutineVariation) {
		steps.push({
			type: 'tooltip',
			target: '#routine-variation',
			subtitle:
				"From here, you can choose the routine variation for that day's lesson.</br>If you need help knowing which lesson to follow, please refer to the current weekly plan.",
			tooltipPlacement: 'left',
			requireTargetActive: true,
			button: {
				label: 'Next',
				type: 'paginated'
			}
		});
	}

	const config: FtuxConfig = {
		id: 'routines-ftux',
		name: 'Routines Tutorial',
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
